import { render, staticRenderFns } from "./IframeModal.vue?vue&type=template&id=9f43e3c8"
import script from "./IframeModal.vue?vue&type=script&lang=ts"
export * from "./IframeModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports